import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';

@Injectable({
  providedIn: 'root',
})
export class ChatWidgetService {

  constructor(private readonly httpService: AmplifyHttpClient) {}

  getMessages() {
    return this.httpService.get(`api/message`).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  sendUserMessage(data: any) {
    return this.httpService.post(`api/message/user`, data).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  sendMessage(data: any) {
    return this.httpService.post(`api/message`, data).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  sendQuestionMessage(data: any) {
    return this.httpService.post(`api/message/question`, data).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  getTipsMessage(data: any) {
    const params = {
      "vault_user_form_id": data.vault_user_form_id,
      "message": data.message,
      "template_type": data.template_type
    }
    return this.httpService.post(`api/message/template-question`, params).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  getSummaryMessage(data: any) {
    const params = {
      "vault_user_form_id": data.vault_user_form_id,
      "message": data.message,
      "template_type": data.template_type
    }
    return this.httpService.post(`api/message/template-summary`, params).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  createCache(body: any = {}) {
    return this.httpService.post(`api/data-extraction/vector-management/create-cache`, body).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  // createSession (POST api/message/create-session) was removed with the
  // legacy in-item AI panel (FormAiChatComponent). In-item chat is Kinnect AI
  // Phase 2: POST /api/kinnect-ai/turn with vault_user_form_id — see
  // src/app/modules/kinnect-ai/.

  updateMessage(data: any) {
    return this.httpService.patch(`api/message/update-message`, data).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  deleteMessage(key: string) {
    return this.httpService.delete(`api/message/${decodeURIComponent(key)}`, {}).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  getUserSessions() {
    return this.httpService.get(`api/message/user-sessions`, {}).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  // getVaultFormSessions / getMessagesBySessionId were removed with the legacy
  // in-item AI panel. Per-item session lists come from
  // GET /api/kinnect-ai/sessions?vault_user_form_id=<id>, transcripts from
  // GET /api/kinnect-ai/sessions/:id/messages (see KaiApi).

  getFormDataForChat(data: any) {
    return this.httpService.post(`api/data-extraction/vector-management/form-data-for-chat`, data).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }
}
